module.exports = __webpack_public_path__ + "img/soster2_v2.f2772752.png";